import(/* webpackMode: "eager" */ "/vercel/path0/src/app/industries/healthcare/page.tsx");
